import api from './api';

const BASE = '/admin/pages';

const pagesService = {
  // Get pages with pagination and filters
  list: (params = {}) => {
    const {
      page = 1,
      limit = 10,
      sortBy = 'created_at',
      sortOrder = 'desc',
      status = 'all',
      search = '',
      isAll = 0,
    } = params;

    return api.get(`${BASE}`, {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        status,
        search,
        isAll,
      },
    });
  },

  getById: (page_id) => api.get(`${BASE}/${page_id}`),
  create: (payload) => api.post(`${BASE}`, payload),
  update: (page_id, payload) => api.put(`${BASE}/${page_id}`, payload),
};

export default pagesService;
